/* eslint-disable no-undef */
import Vue from 'vue';
import VueI18n from 'vue-i18n';

const options = {
  locale                : 'pt-BR',
  silentTranslationWarn : true,
  fallbackLocale        : 'pt-BR'
};

Vue.use(VueI18n);

const core_en = _.merge({ '$vuetify': JSON.parse(JSON.stringify(require('vuetify/lib/locale/en').default)) }, require('~/locales/_core/en.json'));
const core_pt_BR = _.merge({ '$vuetify': JSON.parse(JSON.stringify(require('vuetify/lib/locale/en').default)) }, require('~/locales/_core/pt-br.json'));
const core_es = _.merge({ '$vuetify': require('vuetify/lib/locale/es').default }, require('~/locales/_core/es.json'));


export default ({ app }) => {
  app.i18n = new VueI18n({
    ...options,
    messages: {
      en      : _.merge({ _core: core_en }, require('~/locales/en.json')),
      'pt-BR' : _.merge({ _core: core_pt_BR }, require('~/locales/pt-br.json')),
      es      : _.merge({ _core: core_es }, require('~/locales/es.json'))
    }
  });
};

export {
  options
};
